module.exports = __webpack_public_path__ + "media/ubud/fountain-9d6cc45e.jpg";